import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { aidRecordsService } from "../services/aid-records.service";
import type {
	AidRecordCreateRequest,
	AidRecordUpdateRequest,
	ListAidRecordsParams,
} from "../types";

const QUERY_KEY = "aid-records";

export function useAidRecordsList(params: ListAidRecordsParams) {
	return useQuery({
		queryKey: [QUERY_KEY, params],
		queryFn: () => aidRecordsService.list(params),
		placeholderData: (previous) => previous,
	});
}

export function useCreateAidRecord() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: (data: AidRecordCreateRequest) => aidRecordsService.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Yordam yozuvi qo'shildi");
		},
		onError: () => {
			message.error("Yozuvni qo'shib bo'lmadi");
		},
	});
}

export function useUpdateAidRecord() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: AidRecordUpdateRequest }) =>
			aidRecordsService.update(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Yozuv saqlandi");
		},
		onError: () => {
			message.error("Yozuvni saqlab bo'lmadi");
		},
	});
}

export function useDeleteAidRecord() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: (id: string) => aidRecordsService.remove(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Yozuv o'chirildi");
		},
		onError: () => {
			message.error("Yozuvni o'chirib bo'lmadi");
		},
	});
}
